import type { DocType } from 'src/components/Tourists/types';
import { GENDER } from 'src/constants';
import {
  BIRTH_CERTIFICATE_MASK,
  DOC_TYPES,
} from 'checkout/store/constants/tourists';
import type { SavedTourist } from 'checkout/store/client/types';
import { homoglyphsPairsForBirthCertificate } from '../contstants';

// Max age considered to be a child
export const MAX_CHILD_AGE = 17;
export const MIN_CHILD_AGE = 0;

export const isChild = (age?: number | null) =>
  age !== undefined &&
  age !== null &&
  age >= MIN_CHILD_AGE &&
  age <= MAX_CHILD_AGE;

export const isRuDoc = (docType: DocType) =>
  docType !== DOC_TYPES.international_passport.id;

export const PROPERTIES_TO_COMPARE = [
  'gender',
  'name',
  'docType',
  'passport_number',
  'surname',
  'patronymic',
  'birthday',
  'nationality_id',
];

export const areTouristsEqual = (touristA, touristB) =>
  PROPERTIES_TO_COMPARE.every(
    (property) => touristA[property] === touristB[property],
  );

export const transformSavedTourists = (tourists): SavedTourist[] =>
  tourists.map((tourist) => {
    const { female, doc_type, ...rest } = tourist;
    return {
      ...rest,
      state: 'normal',
      gender: female ? GENDER.FEMALE : GENDER.MALE,
      docType: doc_type,
      // Если с бэка пришло "-" или null, то заменяем его на пустою строку
      patronymic:
        tourist.patronymic === '-' || tourist.patronymic === null
          ? ''
          : tourist.patronymic,
    };
  });

/**
 * Возвращает объект из трех полей - латинские цифры, русские буквы и цифры - из строки формата "номер свидетельства о рождении"
 * @param {string} str - строка формата свидетельство о рождении (II-AA 123456)
 * @return объект из трех строк - latinNumbers, cyrillicLetters, numbers ({"II", "AA", "123456"})
 * */

export const getObjFromBirthCertificateStr = (str) => {
  const [latinNumbers, cyrillicLetters, numbers] = str
    .split(BIRTH_CERTIFICATE_MASK)
    .filter((el) => el);
  return { latinNumbers, cyrillicLetters, numbers };
};
/**
 * Возвращает строку формата "номер свидетельства о рождении" с замененными символами-гомоглифами(символами с похожим написанием)
 * @param {string} str - строка формата свидетельство о рождении (II-AA 123456)
 * @return объект из трех строк - formattedLatinNumbers, formattedCyrillicLetters, numbers ({"II", "AA", "123456"})
 * */

export const formatHomoglyphsForBirthCertificate = (str) => {
  const { latinNumbers, cyrillicLetters, numbers } =
    getObjFromBirthCertificateStr(str);
  let formattedLatinNumbers = latinNumbers;
  let formattedCyrillicLetters = cyrillicLetters;
  homoglyphsPairsForBirthCertificate.forEach((homoglyphPair) => {
    formattedCyrillicLetters = formattedCyrillicLetters.replaceAll(
      homoglyphPair[0],
      homoglyphPair[1],
    );
    formattedLatinNumbers = formattedLatinNumbers.replaceAll(
      homoglyphPair[1],
      homoglyphPair[0],
    );
  });
  return { formattedLatinNumbers, formattedCyrillicLetters, numbers };
};
